module.exports = __webpack_public_path__ + "static/bluecore-3093b1ce66c96b3b0cf1bd2cc9d01798.webp";